<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header-title has-text-right">
        <span>&nbsp;Postingan</span>
      </div>

      <div class="dropdown is-hoverable is-right">
        <div class="dropdown-trigger">
          <button class="button is-text has-text-primary card-header-icon" style="background: white;">
            <span class="icon"><i class="fas fa-filter"></i></span>
            <span v-for="(f, key) in date_filters" :key="key"><span v-if="range == f.value">{{ f.text }}</span></span>
          </button>
        </div>
        <div class="dropdown-menu" role="menu">
          <div class="dropdown-content">
            <a v-for="(f, key) in date_filters" :key="key" href="" class="dropdown-item" @click.prevent="rangeBy(f.value)">
              {{ f.text }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="card-content" style="padding: 15px;">
      <div v-if="!loading_get_data">
        <canvas id="postChart"></canvas>
      </div>            
      <spinner-loading v-else></spinner-loading>
    </div>
  </div>
</template>

<script>
import { REPORT } from '~/consts';

export default {
  mounted() {
    this.getPostStats();
  },

  data() {
    return {
      loading_get_data: false,
      data: [],
      start_date: null,
      end_date: null,
      range: 7,
      date_filters: [
        { value: 7, text: '7 hari terakhir'},
        { value: 30, text: '30 hari terakhir'},
        { value: 90, text: '90 hari terakhir'}
      ]
    }
  },

  methods: {
    rangeBy(days) {
      const vm = this;
      vm.range = days;

      vm.end_date = moment().format('YYYY-MM-DD');
      vm.start_date = moment().subtract(vm.range, 'days').format('YYYY-MM-DD');

      vm.getPostStats();
    },
    getPostStats() {
      const vm = this;

      vm.loading_get_data = true

      let url = REPORT.GET_POST_STATS + (!vm.isEmpty(vm.start_date) || !vm.isEmpty(vm.end_date) ? '?' : '');
      if (!vm.isEmpty(vm.start_date)) {
        url = url + `&start=${vm.start_date}`;
      }

      if (!vm.isEmpty(vm.end_date)) {
        url = url + `&end=${vm.end_date}`;
      }

      this.$axios.post(url)
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.data = data.data
          } else {
            toast.danger(data.applicationSystem.message)
          }

          vm.loading_get_data = false
          Vue.nextTick(() => {
            vm.setChart();
          })
        }).catch(() => {
          vm.loading_get_data = false
        })
    },
    setChart() {
      const vm = this;
      const label = collect(vm.data).pluck('label').toArray();
      const values = collect(vm.data).pluck('value').toArray();

      var ctx = document.getElementById('postChart');
      var postChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: label,
          datasets: [{
            label: 'Banyak Postingan',
            data: values,
            backgroundColor: ['rgba(39, 174, 96, 0.2)'],
            borderColor: ['rgba(39, 174, 96, 1)'],
            borderWidth: 1
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }
      });
    }
  }
}
</script>